import config from './config';
import { profile } from "../stores/storages/ProfileStorage";
import { clientInfo } from '../version'
import formatter from './formatter'
import api from './api'
import { Topic } from '../tinode/topic';

const ChatServices = {
    recallMessage: async (threadId, message) => {
        const { token } = profile.authAPI;
        const { from: fromUsr, id: msgId, type } = message
        const from = Topic.getThreadId(fromUsr)
        const timestamp = new Date().getTime()
        const clientType = clientInfo.platform
        const revision = clientInfo.revision
        const languageCode = clientInfo.language
        const countryCode = clientInfo.country
        const desktop = 1
        const security = formatter.encrypt(`${from}${threadId}${msgId}${type}${clientType}${revision}${languageCode}${countryCode}${desktop}${token}${timestamp}`)
        const formData = new FormData()
        formData.append('from', from)
        formData.append('to', threadId)
        formData.append('msgid', msgId)
        formData.append('type', type)
        formData.append('clientType', clientType)
        formData.append('revision', revision)
        formData.append('languageCode', languageCode)
        formData.append('countryCode', countryCode)
        formData.append('desktop', desktop)
        formData.append('timestamp', timestamp)
        formData.append('security', security)

        const options = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            decrypt: false,
        }

        const res = await api.request({
            method: config.endpoints.chat.recallMessage.method,
            path: config.endpoints.chat.recallMessage.path,
            host: config.host,
            data: formData,
            options,
        })
        return res
    },
}

export default ChatServices